import apiClient from './api'
import { useAuthStore } from '../stores/authStore'

export interface MeResponse {
  email: string
  first_name?: string
  last_name?: string
  role: 'admin' | 'agent_manager' | 'viewer'
  can_manage_agents?: boolean
}

export const authService = {
  /**
   * Check if user is authenticated by calling /me endpoint.
   * Returns null only when signed out (401). Any other failure (503, network)
   * throws, so an outage shows "try again" instead of a login loop.
   */
  async checkAuth(): Promise<MeResponse | null> {
    try {
      const response = await apiClient.get<MeResponse>('/me')
      return response.data
    } catch (error: any) {
      if (error?.response?.status === 401) return null
      console.error('Auth check failed:', error)
      throw error
    }
  },

  /**
   * Logout user by calling /auth/logout
   */
  async logout(): Promise<void> {
    try {
      await apiClient.post('/auth/logout')
      useAuthStore.getState().logout()
      window.location.href = '/login'
    } catch (error) {
      console.error('Logout failed:', error)
      // Even if logout fails, clear local state and redirect
      useAuthStore.getState().logout()
      window.location.href = '/login'
    }
  },
}
